export default __webpack_public_path__ + "static/media/likeBlack.0faa202f.svg";